import { useCallback, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import debounce from 'lodash/debounce';

const AutoSubmit = ({ debounce: debounce$1 = 1000, initialValues, onSubmit, }) => {
    const { handleSubmit, watch, formState: { isSubmitting }, } = useFormContext();
    const handleSubmitForm = useCallback(debounce(() => {
        handleSubmit(onSubmit)();
    }, debounce$1), []);
    useEffect(() => {
        const subscription = watch(values => {
            if (values === initialValues || isSubmitting)
                return;
            handleSubmitForm();
        });
        return () => subscription.unsubscribe();
    }, [watch]);
    return null;
};

export { AutoSubmit as default };
//# sourceMappingURL=index.js.map
